import { TemplatesData as TemplatesDataType } from './useTemplatesStore';
import { LinksetsData as LinksetsDataType } from './useLinksetsStore';

import { VideoAppearanceData as IVideoAppearanceData } from './useVideoAppearance';
interface OverlaysDataType {
  id: string;
  title: string;
}

export enum RecipientType {
  USER = '2',
  GROUP = '1',
}
export interface RecipientInterface {
  type: string;
  id: string;
  text: string;
}
export type LinksetsData = LinksetsDataType;
export type TemplatesData = TemplatesDataType;
export type OverlaysData = OverlaysDataType;
export type Recipient = RecipientInterface;
export type VideoData = {
  id: string;
  title: string;
  recordDate: string;
  autogeneratedThumbnail: string;
  videoSource: string;
  personalThumbnail: string;
  playerBackgroundColor: string;
  playerIconsAndTextColor: string;
  playButtonPosition: string;
  wtvId?: number;
  emailStatus: string;
  protected?: boolean | string;
  videoLength?: number;
  reactionsPreference?: boolean;
  videoReplyEnabled?: boolean;
  userId?: number;
  isGuide?: boolean;
};
export type VideoAppearanceData = IVideoAppearanceData;
// get all templates
export { useTemplatesStore } from './useTemplatesStore';
// get all video appearance
export { useVideoAppearanceStore } from './useVideoAppearance';
// get all linksets
export { useLinksetsStore } from './useLinksetsStore';
// move/copy video
export { useVideoMoveCopy } from './useVideoMoveCopy';
export { useVideoMoveCopyMultiple } from './useVideoMoveCopyMultiple';

// generate share link
export { getExpressQuickShareLink } from './useVideoShareLink';

export { useVideoTranscriptionUpdate } from './useVideoTranscriptionUpdate';

export { useVideoTranscriptionStart } from './useVideoTranscriptionStart';

export { useVideoViewersMessagesStore } from './useVideoViewersMessagesStore';
export { useVideoViewersNotify } from './useVideoViewersNotify';

export { useQueryFetch } from './useQueryFetch';

//upload video
export { useCreateVideo } from './useCreateVideo';
export { usePresignedUrl } from './usePresignedUrl';
export { useS3Upload } from './useS3Upload';
export { useEncodeVideo } from './useEncodeVideo';

//Auth
export { useAuth } from './useAuth';

export { usePrevious } from './usePrevious';

export { useContainerDimensions } from './useContainerDimensions';

export { useGetReport } from './useGetReport';

// error toast

export { useToastError } from './useToastError';
export { useToastBlock } from './useToastBlock';
